import {
	IonBadge,
	IonButton,
	IonButtons,
	IonIcon,
	IonItem,
	IonLabel,
	IonList,
} from "@ionic/react";
import { createOutline } from "ionicons/icons";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import Spacer from "../../../components/spacer";
import { getEntries } from "../../../services/users";
import { formatDate } from "../../../services/util";

interface props {
	user: any;
	dateTS: any;
}

const DateToiletView: React.FC<props> = ({ dateTS, user }) => {
	const history = useHistory();
	const [entries, setEntries] = useState<any>([]);
	const [overnight, setOvernight] = useState<boolean>(false);

	useEffect(() => {
		if (!user.id) user.id = user.uid;
		if (user && user.id && dateTS) {
			getEntries(user.id).then((docs: any) => {
				let validEntries = Object.values(docs).filter(
					(doc: any) => doc.dateTS === dateTS
				);
				setEntries(validEntries);
			});
		}
	}, [user]);

	useEffect(() => {
		if (entries) {
			// console.log(entries);
			let overnights = entries.filter(
				(el: any) => el.entryType === "overnight"
			);
			if (overnights.length > 0) {
				setOvernight(true);
			}
		}
	}, [entries]);

	const _sortByTime = (a: any, b: any) => {
		if (a.time && b.time) {
			let valueA = a.time.replace(":", "");
			let valueB = b.time.replace(":", "");
			return valueA - valueB;
		}
	};

	const getDate = () => {
		return formatDate(parseInt(dateTS));
	};

	return (
		<>
			<IonList>
				{entries && (
					<>
						<h1>Entries for {getDate()} </h1>
						<Spacer size="30" />
						{entries.length === 0 && <p>You have not made any entries yet</p>}

						{entries.sort(_sortByTime).map((el: any, idx: any) => (
							<IonItem
								button
								key={idx}
								onClick={() => history.push(`/users/${user.id}/entry/${el.id}`)}
							>
								{el.entryType !== "overnight" && <IonLabel>{el.time}</IonLabel>}
								{el.entryType === "accident" && (
									<IonBadge color="primary">Accident</IonBadge>
								)}
								{el.entryType === "overnight" && (
									<>
										<IonLabel>Overnight Report</IonLabel>
										<IonBadge color="secondary">Overnight</IonBadge>
									</>
								)}
								{el.entryType === "regular" && (
									<IonBadge color="tertiary">Regular</IonBadge>
								)}

								<IonIcon slot="end" icon={createOutline} />
							</IonItem>
						))}
					</>
				)}
			</IonList>
			<Spacer size="30" />
			<IonButtons>
				<IonButton
					onClick={() =>
						history.push(`/users/${user.id}/entry/new/${dateTS}/regular`)
					}
				>
					Add Entry
				</IonButton>
				<IonButton
					onClick={() =>
						history.push(`/users/${user.id}/entry/new/${dateTS}/accident`)
					}
				>
					Add Accident
				</IonButton>
				{!overnight && (
					<IonButton
						onClick={() =>
							history.push(`/users/${user.id}/entry/new/${dateTS}/overnight`)
						}
					>
						Add Overnight Report
					</IonButton>
				)}
			</IonButtons>
		</>
	);
};

const mapStateToProps = (state: any) => ({
	usersData: state.user.users,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DateToiletView);
